export var typography = {
    fontFamily: '"Overpass", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h1: {
        fontWeight: 300,
        fontSize: '2.1875rem',
    },
    h2: {
        fontWeight: 700,
        fontSize: '1.75rem',
    },
    h3: {
        fontWeight: 400,
        fontSize: '1.53125rem',
    },
    h4: {
        fontWeight: 900,
        fontSize: '1.09375rem',
    },
    h5: {
        fontWeight: 800,
        fontSize: '1rem',
    },
    h6: {
        fontWeight: 800,
        fontSize: '0.875rem',
    },
    body1: {
        fontWeight: 400,
        fontSize: '0.875rem',
    },
    body2: {
        fontWeight: 400,
        fontSize: '0.75rem',
    },
};
//# sourceMappingURL=typography.js.map